export const DECK_OPTIONS_COPY_OVERRIDES: Record<string, string> = {
  driverSpecificInputPreferences: 'Input Plates',
  driverSpecificOutputPreferences: 'Output Plates',
  driverSpecificTemporaryLocations: 'Temporary Locations',
  driverSpecificTipPreferences: 'Tip Boxes',
  driverSpecificTipWastePreferences: 'Tip Wastes',
  liquidHandlingPolicyXlsxJmpFile: 'Custom Policy XLSX File',
};
